import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, Button, TextField, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter, useParams } from "react-router-dom";
import AdminEventService from "../dashboard/Locality/Service/adminEventService";
import Header from "./Header";
import Footer from "./Footer";
import './styles/bootstrap.min.css';
import './styles/main.css';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import * as Yup from 'yup';
import { useFormik } from 'formik';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(4),
        paddingTop: '120px',
        minHeight: 'calc(100vh - 120px)',
        backgroundColor: '#f5f5f5',
        marginTop: 0,
        position: 'relative',
        zIndex: 1,
    },
    contentContainer: {
        maxWidth: '800px',
        margin: '0 auto',
    },
    backButton: {
        marginBottom: theme.spacing(2),
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        color: '#666',
        '&:hover': {
            color: '#ff6b81',
        },
    },
    bookingCard: {
        padding: theme.spacing(3),
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
    },
    eventTitle: {
        fontSize: '1.8rem',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: theme.spacing(3),
        textAlign: 'center',
    },
    formField: {
        marginBottom: theme.spacing(2),
    },
    submitButton: {
        backgroundColor: '#ff6b81',
        color: '#fff',
        padding: theme.spacing(1.5, 4),
        fontWeight: 'bold',
        marginTop: theme.spacing(2),
        width: '100%',
        '&:hover': {
            backgroundColor: '#ff5570',
        },
    },
    loading: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: '#999',
    },
    error: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: '#d32f2f',
    },
}));

function EventBooking(props) {
    const classes = useStyles();
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (id) {
            getEventDetails();
        }
    }, [id]);

    const getEventDetails = () => {
        setLoading(true);
        AdminEventService.getAdminEventById(id)
            .then((res) => {
                setEvent(res);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setError('Failed to load event details');
                setLoading(false);
            });
    };

    const validationSchema = Yup.object().shape({
        mobileNumber: Yup.string()
            .required('Mobile number is required')
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits'),
    });

    const formik = useFormik({
        initialValues: {
            mobileNumber: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // Handle booking submission here
            console.log('Booking submitted:', values);
            alert('Booking functionality will be implemented here. Mobile: ' + values.mobileNumber);
            // You can add API call here to process the booking
        },
    });

    const handleBack = () => {
        props.history.push(`/event/${id}`);
    };

    if (loading) {
        return (
            <>
                <Header history={props.history} />
                <Box className={classes.container}>
                    <Typography className={classes.loading}>Loading event details...</Typography>
                </Box>
                <Footer />
            </>
        );
    }

    if (error || !event) {
        return (
            <>
                <Header history={props.history} />
                <Box className={classes.container}>
                    <Typography className={classes.error}>{error || 'Event not found'}</Typography>
                    <Button onClick={handleBack} style={{ marginTop: 16 }}>Back to Event</Button>
                </Box>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header history={props.history} />
            <Box className={classes.container}>
                <div className={classes.contentContainer}>
                    <div className={classes.backButton} onClick={handleBack}>
                        <ArrowBackIcon style={{ marginRight: 8 }} />
                        Back to Event
                    </div>

                    <Card className={classes.bookingCard}>
                        <CardContent>
                            <Typography className={classes.eventTitle}>
                                {event.eventName}
                            </Typography>

                            <form onSubmit={formik.handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="mobileNumber"
                                            name="mobileNumber"
                                            label="Mobile Number"
                                            type="tel"
                                            variant="outlined"
                                            value={formik.values.mobileNumber}
                                            onChange={formik.handleChange}
                                            error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                                            helperText={formik.touched.mobileNumber && formik.errors.mobileNumber || "Enter your 10-digit mobile number"}
                                            inputProps={{
                                                maxLength: 10,
                                                pattern: "[0-9]*"
                                            }}
                                            className={classes.formField}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            className={classes.submitButton}
                                            disabled={!formik.isValid || formik.isSubmitting}
                                        >
                                            {formik.isSubmitting ? 'Processing...' : 'Book Now'}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </div>
            </Box>
            <Footer />
        </>
    );
}

export default withRouter(EventBooking);

